import { Contractors } from "./components/Contractors";
import { SearchField } from "../components";
import { useSearchParams } from "react-router-dom";

export function ContractorList() {
  const [searchParams] = useSearchParams();
  const searchString = searchParams.get("search") ?? undefined;

  return (
    <>
      <h3 className="mb-2">Contractors</h3>
      <div className="mb-3">
        <SearchField />
      </div>

      <Contractors filters={{ searchString }} expanded={true} allowExpand={false} />
    </>
  );
}
